export default "__VITE_ASSET__DvR$Wm6Q__"